import {HttpClientModule} from '@angular/common/http';
import {NgModule, Optional, SkipSelf} from '@angular/core';
import {UpgradeModule} from '@angular/upgrade/static';
import {providers as appV1Providers} from '@app/v1_integration';
import {httpInterceptorProviders} from '@core/communication';
import {AuthService, LoggerService, UIStatusService} from '@core/services';
import {AuthGuard} from '@services/auth-guard.services';
import {CommonService} from '@services/common.services';
import {UserService} from '@services/user.services';
import {StorageServiceModule} from 'ngx-webstorage-service';

/**
 * Core Module
 * CoreModule is a conventional name for an NgModule with providers for the singleton services you load when the application starts.
 *
 * IMPORTANT: This module should expose global singleton services.
 * Import CoreModule in the root AppModule only and NEVER import CoreModule in any other feature module.
 */
@NgModule({
  imports: [StorageServiceModule],
  exports: [UpgradeModule, HttpClientModule],
  providers: [
    appV1Providers,
    httpInterceptorProviders,
    AuthService,
    UserService,
    CommonService,
    LoggerService,
    UIStatusService,
    AuthGuard
  ]
})
export class CoreModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: CoreModule
  ) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the root AppModule only'
      );
    }
  }
}
